export const accessoryTempCodeName = 'accessory';